"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchCannabinoidHelpers = void 0;
class BatchCannabinoidHelpers {
}
exports.BatchCannabinoidHelpers = BatchCannabinoidHelpers;
BatchCannabinoidHelpers.hasBatchCannabinoidMetadata = (batch) => {
    if (!batch.cannabinoidMetaData ||
        batch.cannabinoidMetaData.length === 0 ||
        !batch.cannabinoidMetaData[0].metaData) {
        return false;
    }
    return batch.cannabinoidMetaData[0].metaData.some((data) => data.metaValue !== null &&
        (data.metaKey.toLowerCase().includes('thc') || data.metaKey.toLowerCase().includes('cbd')));
};
BatchCannabinoidHelpers.isBatchInRange = (batch, product, potencyFilterOptions) => {
    if (!product)
        return false;
    const batchMetaDataIsNotPresent = !batch ||
        !batch.cannabinoidMetaData ||
        batch.cannabinoidMetaData.length === 0 ||
        !batch.cannabinoidMetaData[0].metaData;
    if (batchMetaDataIsNotPresent) {
        return potencyFilterOptions.isProductMetaDataInRange(product.metaData);
    }
    return potencyFilterOptions.isBatchMetaDataInRange(batch, product.metaData);
};
//# sourceMappingURL=BatchCannabinoidHelpers.js.map